export const googleApiKey = process.env.GOOGLE_API_KEY;

export const country =
  process.env.COUNTRY != null && process.env.COUNTRY !== ''
    ? process.env.COUNTRY.replace(' ', '').split(',')
    : 'DK';
